import { Injectable } from '@angular/core';
import { Validators } from '@angular/forms';

import { UntypedFormBuilder, UntypedFormGroup } from '@angular/forms';

@Injectable({
    providedIn: 'root'
})
export class CourtEventNoteSaveFormService {
    constructor(private formBuilder: UntypedFormBuilder) {}

    public initForm(): UntypedFormGroup {
        return this.formBuilder.group({
            note: [null, [Validators.required]]
        });
    }
}
